import React from 'react';
import { CaretLeft, CaretRight } from 'phosphor-react';

interface PaginacaoProps {
  /** Página atual, a partir de 0 (como o Spring devolve). */
  pagina: number;
  totalPaginas: number;
  onMudar: (pagina: number) => void;
  className?: string;
}

const BOTAO =
  'flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ' +
  'bg-white dark:bg-gray-800 text-nude-500 dark:text-gray-300 border border-nude-200 dark:border-gray-700 ' +
  'hover:border-blush-300 hover:text-blush-500 disabled:opacity-40 disabled:pointer-events-none';

/** Anterior / "Página X de Y" / Próxima embaixo de toda listagem. Some com uma página só. */
export default function Paginacao({ pagina, totalPaginas, onMudar, className = '' }: PaginacaoProps) {
  if (totalPaginas <= 1) return null;

  return (
    <nav aria-label="Paginação" className={`flex items-center justify-between gap-3 ${className}`}>
      <button type="button" onClick={() => onMudar(pagina - 1)} disabled={pagina === 0} className={BOTAO}>
        <CaretLeft className="w-3.5 h-3.5" /> Anterior
      </button>
      <span className="text-xs text-nude-400 dark:text-gray-500" aria-live="polite">
        Página {pagina + 1} de {totalPaginas}
      </span>
      <button
        type="button"
        onClick={() => onMudar(pagina + 1)}
        disabled={pagina >= totalPaginas - 1}
        className={BOTAO}
      >
        Próxima <CaretRight className="w-3.5 h-3.5" />
      </button>
    </nav>
  );
}
